// actionTypes/cart.js
export const ADD_TICKET = "ADD_TICKET";
export const REMOVE_TICKET = "REMOVE_TICKET";
export const EMPTY_CART = "EMPTY_CART";
export const SET_TICKET_TO_ZERO = "SET_TICKET_TO_ZERO"; // New action type
